const n = {
  default: "",
  danger: "d-modal--danger"
}, a = {
  default: "",
  full: "d-modal--full"
}, d = {
  error: "d-modal__banner--critical",
  info: "d-modal__banner--info",
  success: "d-modal__banner--success",
  warning: "d-modal__banner--warning",
  base: "d-modal__banner--general"
};
export {
  d as MODAL_BANNER_KINDS,
  n as MODAL_KIND_MODIFIERS,
  a as MODAL_SIZE_MODIFIERS
};
//# sourceMappingURL=modal-constants.js.map
